export default function (string) {
  return string && string.replace(/[A-Z]/g, _ => ' ' + _.toLowerCase())
}
